import { warehouseApi } from "./warehouseApi";

export interface ServerVersion {
  tag: string;
  hash: string;
}

const versionApi = warehouseApi.injectEndpoints({
  endpoints: (build) => ({
    getServerVersion: build.query<ServerVersion, void>({
      query: () => ({
        // version.json is at root, not under /api, so use relative path from api
        url: `../version.json?v=${Date.now()}`,
        headers: { "Cache-Control": "no-cache" }
      })
    })
  }),
  overrideExisting: false
});

export const { useGetServerVersionQuery } = versionApi;
